import * as React from 'react';
import { t } from 'i18next';

import { MessageBoxType } from '../constants/Enums';
import { ViewSettingsActions } from '../actions/ViewSettingsActions';
import { MessageBoxContentProps, MessageBoxContent } from '../components/MessageBoxContent';

import utils = egr.wcf.utils;
import eaiws = egr.wcf.eaiws;
import { IgnoreAjaxErrorHandlerError } from '../submodules/utils/AjaxErrorHandler';

export abstract class AjaxErrorHandler {
    protected static networkErrorQueue: Array<utils.async.AjaxErrorInfo> = [];

    public static handler(error: utils.async.AjaxErrorInfo): void {
        let handled: boolean = false;
        if (!(error.responseError instanceof IgnoreAjaxErrorHandlerError)) {
            if (error.responseError instanceof eaiws.SoapError) {
                // Note: double checking of `isinstance` vs another function argument (ts type guard)
                handled = AjaxErrorHandler.handleSoapError(error.responseError, error);
            } else if (error.status === 0) { // Network error
                handled = AjaxErrorHandler.handleNetworkError(error);
            }
        }

        if (handled !== true) {
            error.reject();
        }
    }

    public static retryNetworkRequests(): void {
        AjaxErrorHandler.networkErrorQueue.forEach((error: utils.async.AjaxErrorInfo): void => {
            error.retry();
        });
        AjaxErrorHandler.networkErrorQueue.length = 0;
        ViewSettingsActions.hideNetworkError();
    }

    protected static handleNetworkError(error: utils.async.AjaxErrorInfo): boolean {
        AjaxErrorHandler.networkErrorQueue.push(error);
        ViewSettingsActions.showNetworkError();
        return true;
    }

    protected static handleSoapError(soapError: eaiws.SoapError, error: utils.async.AjaxErrorInfo): boolean {
        if (soapError.message.indexOf('unknown session:') === 0) {
            ViewSettingsActions.showMessage({
                wrap: false,
                element: React.createElement<MessageBoxContentProps>(
                    MessageBoxContent,
                    {
                        submitText: t('Start a new session'),
                        submitCallback: (): void => {
                            window.location.reload();
                        },
                        wideButtons: true
                    },
                    React.createElement(
                        'div',
                        {},
                        [
                            t('Your session has expired.'),
                            React.createElement('br'),
                            t('To configure articles you have to start a new session.'),
                            React.createElement('br'),
                            t('Attention: Your drawing will be cleared then.'),
                        ]
                    )
                ),
                type: MessageBoxType.DEFAULT
            });
            return true;
        }
        return false;
    }
}


// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/utils/AjaxErrorHandler.ts